import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toggleModal } from "../store/common";
import { changeApprovementCSV, importCSVdata } from "../store/cart";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table
} from "reactstrap";
import Redbtn from "../molecules/components/RedBtn";
import { RingLoader } from "react-spinners";
import { getTranslate } from "react-localize-redux";

const ImportCSVModal = ({
  getModalStatus,
  toggleModal,
  changeApprovementCSV,
  csvData,
  importCSVdata,
  isImporting,
  translate
}) => (
  <Modal
    size="lg"
    className="import_csv_modal"
    isOpen={getModalStatus}
    toggle={() => toggleModal("import_csv_modal", false)}
  >
    <ModalHeader>
      {" "}
      <h1>{translate("containers.importCSVModal.modal_header")}</h1>
    </ModalHeader>
    <ModalBody>
      <RingLoader
        color={"#d42e2b"}
        loading={isImporting}
        size={120}
        margin={20}
      />
      {!isImporting && (
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>{translate("containers.importCSVModal.product_code")}</th>
              <th>{translate("containers.importCSVModal.product_quantity")}</th>
            </tr>
          </thead>
          <tbody>
            {csvData &&
              csvData.length > 0 &&
              csvData.map((row, index) => (
                <tr key={index}>
                  <th>
                    <input
                      type="checkbox"
                      name={"ch_" + index}
                      defaultChecked={row.approved}
                      onClick={() => changeApprovementCSV(index)}
                    />
                  </th>
                  <td>{row.code}</td>
                  <td>{row.quantity}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      )}
    </ModalBody>
    <ModalFooter>
      <Button
        color="secondary"
        onClick={() => toggleModal("import_csv_modal", false)}
      >
        {translate("containers.importCSVModal.close")}
      </Button>
      <Redbtn
        icon="fa fa-shopping-cart"
        title={translate("containers.importCSVModal.import")}
        action={() => importCSVdata()}
      />
    </ModalFooter>
  </Modal>
);

ImportCSVModal.propTypes = {};

const mapStateToProps = ({ cart, common, locale }) => ({
  translate: getTranslate(locale),
  getModalStatus: common.modals.import_csv_modal
    ? common.modals.import_csv_modal
    : null,
  csvData: cart.temporalImportedData || [],
  isImporting: cart.loadingImport
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, action)),
  changeApprovementCSV: index => dispatch(changeApprovementCSV(index)),
  importCSVdata: () => dispatch(importCSVdata())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportCSVModal);



// WEBPACK FOOTER //
// ./src/containers/ImportCSVModal.js